//any type checked blueice
import { Discount } from '../../discount/discount.model';

export interface IPeriodDiscount {
    discount?: Discount;
    amount?: number;
    formula?: string;
    formulaType?: FormulaType;
    valueType?: ValueType;
}

export const FormulaType = {
    GROOVY: 'GROOVY',
    JAVA_SCRIPT: 'JAVA_SCRIPT',
    DEFAULT: 'DEFAULT',
} as const;
export type FormulaType = (typeof FormulaType)[keyof typeof FormulaType];

export const ValueType = {
    FIXED_VALUE: 'FIXED_VALUE',
    FORMULA: 'FORMULA',
} as const;
export type ValueType = (typeof ValueType)[keyof typeof ValueType];

export class PeriodDiscount implements IPeriodDiscount {
    constructor(
        public discount?: Discount,
        public amount?: number,
        public formula?: string,
        public formulaType?: FormulaType,
        public valueType?: ValueType
    ) {
        this.discount = discount ? discount : new Discount();
        this.amount = amount ? amount : 0;
        this.formula = formula ? formula : '';
        this.formulaType = formulaType ? formulaType : FormulaType.DEFAULT;
        this.valueType = valueType ? valueType : ValueType.FIXED_VALUE;
    }
}
